import React, { useState } from 'react'
import Nav from 'react-bootstrap/Nav';
import { useTranslation } from 'react-i18next';

export default function ReportNav({ onTabChange }) {
     const [activeTab, setActiveTab] = useState('gstr1');
     const { t } = useTranslation();

     const handleTabSelect = (selectedTab) => {
          setActiveTab(selectedTab);
          onTabChange(selectedTab);
     };
     return (
          <Nav variant="tabs" defaultActiveKey="profile" onSelect={handleTabSelect}>
               <Nav.Item>
                    <Nav.Link eventKey="gstr1" active={activeTab === 'gstr1'} className="nav-link">
                         {t('gstr1')}
                    </Nav.Link>
               </Nav.Item>
               <Nav.Item>
                    <Nav.Link eventKey="gstr3b" active={activeTab === 'gstr3b'} className="nav-link">
                         {t('gstr3b')}
                    </Nav.Link>
               </Nav.Item>
               <Nav.Item>
                    <Nav.Link eventKey="tds" active={activeTab === 'tds'} className="nav-link">
                         {t('tds_tcs')}
                    </Nav.Link>
               </Nav.Item>
               <Nav.Item>
                    <Nav.Link eventKey="invoice" active={activeTab === 'invoice'} className="nav-link">
                         {t('invoice')}
                    </Nav.Link>
               </Nav.Item>
               <Nav.Item>
                    <Nav.Link eventKey="product" active={activeTab === 'product'} className="nav-link">
                         {t('product')}
                    </Nav.Link>
               </Nav.Item>
          </Nav>
     )
}
